import classNames from "classnames/bind";
import { ProductCard } from "../ProductCard";
import { ProductListLayout } from "../../types/types";
import styles from "./CenteredGrid.module.scss";
import { getProductKey } from "../utils/getProductKey";
import { ColumnStyles } from "../shared/ColumnStyles";

const cx = classNames.bind(styles);

export const CenteredGrid: ProductListLayout = ({
  configProps,
  config,
  products,
  instanceId,
  consumerId,
}) => {
  const columnsByCardCount = configProps?.columnsByCardCount as
    Record<number | "default", Record<string, number>> | undefined;

  return (
    <>
      <ColumnStyles
        columnsByBreakpoint={
          columnsByCardCount?.[products.length] || columnsByCardCount?.default
        }
        className={cx("centered-container")}
      />
      <section
        className={cx("centered-container")}
        data-testid="centered-grid-container"
      >
        {products.map((product, ind) => (
          <ProductCard
            key={getProductKey(product)}
            product={product}
            config={config}
            index={ind}
            instanceId={instanceId}
            consumerId={consumerId}
          />
        ))}
      </section>
    </>
  );
};
